import './config/config'
import Vue from 'vue';
import './utils/direction'
import App from './view/App/App.vue'
import axios from './utils/axios.js'
import api from './api/api.js'
import Vuex from "vuex"
import router from './router/index.js'
import storeObj from "./store"
import Antd from "ant-design-vue";
import "./view/home/reset.scss"
import "ant-design-vue/dist/antd.css";
import "./style/globel.scss"
import { message } from 'ant-design-vue'
import SSO from '@/cas/sso.js'
Vue.prototype.$api = api
Vue.prototype.$message = message
Vue.prototype.$axios = axios
Vue.use(Vuex)
const store = new Vuex.Store(storeObj)
Vue.prototype.$store = store
Vue.use(Antd)
Vue.use(store)
SSO.init(() => {
    main()
})

function main() {
    new Vue({
        store,
        router,
        render: (h) => h(App),
    }).$mount("#app");
}
Vue.config.productionTip = false;